import React from 'react';
import { Paper, Box } from '@mui/material';

class PhotoThumb extends React.Component {
  render() {
    const { src, alt } = this.props;

    return (
      <Paper
        variant="outlined"
        sx={{
          p: 0.5,
          width: 120,
          height: 90,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {src ? (
          <img
            src={src}
            alt={alt}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              borderRadius: 4
            }}
          />
        ) : (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              bgcolor: 'action.hover',
              borderRadius: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'text.secondary',
              fontSize: 12
            }}
          >
            No photo
          </Box>
        )}
      </Paper>
    );
  }
}

export default PhotoThumb;
